export default __webpack_public_path__ + "static/media/tasks_open_tasks.76fb2c94.svg";